"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderRoutes = void 0;
const route_1 = require("../route");
class OrderRoutes extends route_1.Route {
    constructor() {
        super('orders');
    }
    getOrderById(orderId) {
        return this.get(`/${orderId}`);
    }
    initializeOrder(orderDetails) {
        return this.post('/initialize', orderDetails);
    }
    completeOrder(orderId, paymentDetails = {}) {
        return this.post(`/complete/${orderId}`, paymentDetails);
    }
    getOrderTemplates() {
        return this.get('/templates');
    }
    getOrderTemplate(templateId) {
        return this.get(`/templates/${templateId}`);
    }
    createOrderTemplate(amount, note, redirectUrl) {
        return this.post('/templates', { amount, note, redirectUrl });
    }
    updateOrderTemplateStatus(templateId, status) {
        return this.post(`/templates/${templateId}/status`, { status });
    }
}
exports.OrderRoutes = OrderRoutes;
//# sourceMappingURL=orders.js.map